module.exports = __webpack_public_path__ + "static/media/edms-logo.1f797fec.png";